import { render, staticRenderFns } from "./ClubLHS.vue?vue&type=template&id=dc4fec2c&scoped=true&"
import script from "./ClubLHS.vue?vue&type=script&lang=js&"
export * from "./ClubLHS.vue?vue&type=script&lang=js&"
import style0 from "./ClubLHS.vue?vue&type=style&index=0&id=dc4fec2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4fec2c",
  null
  
)

export default component.exports